export function getDraggableItemStyle({ isDragging, style }) {
  if (!isDragging) {
    return style
  }

  return {
    ...style,
    backgroundColor: 'var(--color-bg-surface)',
    borderRadius: '4px',
    boxShadow: '0px 4px 18px var(--color-box-shadow-16)',
  }
}
